/**
 * Determine which cell type is non-null in ApiDetailHeaderTableCell
 * All properties are present but only one is non-null (mutually exclusive)
 * @param {ApiDetailHeaderTableCell} cell - The cell to check
 * @returns {{ type: string | null, data: any }} The cell type and its data
 */
export const getDetailHeaderTableCellType = (cell) => {
  if (!cell) return { type: null, data: null };

  // Check in order: text, markdown, boolean, icon, image
  // Properties are mutually exclusive - only one is non-null
  if (cell.text !== null && cell.text !== undefined) return { type: 'text', data: cell.text };
  if (cell.markdown !== null && cell.markdown !== undefined) return { type: 'markdown', data: cell.markdown };
  if (cell.boolean !== null && cell.boolean !== undefined) return { type: 'boolean', data: cell.boolean };
  if (cell.icon !== null && cell.icon !== undefined) return { type: 'icon', data: cell.icon };
  if (cell.image !== null && cell.image !== undefined) return { type: 'image', data: cell.image };

  return { type: null, data: null };
};
